import EventBus from './Event/index.js';
import { preqSaveFields, preqGetFields } from "./api_client/api_prequalification";
import { coappGetUserCoapplicants } from './api_client/api_coapplicant.js';
import { getFileFieldInfoEl, onPhoneValueChange, validators, onMoneyValueChange } from './utils/utils-form.js';

const demoFields = {
  "preq_owner_user": "mauricio@toptal.com",
  "preq_legal_first_name": "Mauricio",
  "preq_legal_middle_name": "Jose",
  "preq_legal_last_name": "Flores Sandoval",
  "preq_phone_number": "1234567890",
  "preq_date_of_birth": "1988-05-17",
  "preq_address_1": "Atlanta, GA, USA",
  "preq_unit_number_1": "123",
  "preq_start_month_1": "01",
  "preq_start_year_1": "2017",
  "preq_end_month_1": "01",
  "preq_end_year_1": "2024",
  "preq_residency_type_1": "rent_free",
  "preq_landlords_email_1": "landlord@gmail.com",
  "preq_landlords_phone_number_1": "1234567890",
  "preq_agree_contact_landlords": "true",
  "preq_employment_status_1": "unemployed",
  "preq_employer_name_1": "Employer 1",
  "preq_employment_title_1": "Position 1",
  "preq_employment_start_month_1": "05",
  "preq_employment_start_year_1": "2020",
  "preq_employment_end_month_1": "02",
  "preq_employment_end_year_1": "2024",
  "preq_employer_paycheck_1": "3000",
  "preq_employment_pay_freq_1": "26",
  "preq_employer_address_1": "at",
  "preq_employment_ref_name_1": "Supervisor 1",
  "preq_employment_ref_phone_number_1": "90877642342",
  "preq_employment_ref_email_1": "supemail@gmail.com",
  "preq_agree_contact_employers": "true",
  "preq_income_source_1": "Gig work",
  "preq_income_amount_1": "200",
  "preq_income_freq_1": "12",
  "preq_coapp_first_name_1": "Coapp 1",
  "preq_coapp_last_name_1": "Coapp last name 1",
  "preq_coapp_email_1": "coapp@gmail.com",
  "preq_coapp_phone_number_1": "12342345",
  "preq_emcon_first_name": "Emergency 1",
  "preq_emcon_last_name": "emergency last name",
  "preq_emcon_relation": "Sibling",
  "preq_emcon_email": "emergency@email.com",
  "preq_emcon_phone_number_1": "12341234123",
  "preq_children": "2",
  "preq_smoke": "yes",
  "preq_pets": "yes",
  "preq_pets_description": "Pets details here",
  "preq_detained_evicted": "yes",
  "preq_eviction_detail": "Eviction detail here",
  "preq_bankruptcy": "yes",
  "preq_bankruptcy_detail": "bankruptcy detail here",
  "preq_ofac_sanctions": "yes",
  "preq_ofac_sanctions_detail": "ofac detail here",
  "preq_sex_offender": "yes",
  "preq_sex_offender_detail": "sex offender detail here",
  "preq_criminal_offense": "yes",
  "preq_criminal_offense_detail": "criminal detail here",
  "preq_savings": "30000",
  "preq_expenses_student_loan": "200",
  "preq_expenses_auto": "300",
  "preq_expenses_credit_cards": "500",
  "preq_expenses_other_debts": "1000",
  "preq_expenses_other_obligations": "300",
  "proof_of_income": "https://ucarecdn.com/30e178b9-3a7d-4def-91ed-69ddf4dd5e88/",
  "proof_of_savings": "https://ucarecdn.com/c7a7e0e1-2045-40fd-bb21-b8bc5e7a8359/",
  "photo_id": "https://ucarecdn.com/02d9a46e-4e4d-4f50-8425-392105c128c2/",
  "other_documents": "https://ucarecdn.com/afa17d3a-5249-4da9-9d3e-ff06494f808b/",
  "preq_agree_info_is_true": "true",
  "preq_agree_soft_credit": "true",
  "street_address": "",
  "city": "Atlanta",
  "state": "Georgia",
  "zip_code": ""
}

class PrequalificationForm {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$inputs = this.$el.find('input, select, textarea, hidden');
    this.$actionSaveStep = this.$el.find('[data-form-action="save"]');
    this.$actionNextStep = this.$el.find('[data-form-action="next"]');
    this.$actionSubmit = this.$el.find('[data-form-action="submit"]');
    this.$conditionalFields = this.$el.find('[data-conditioned-by]');
    this.$landlordFields = this.$el.find('[data-landlord-fields]');
    this.$agreeContactLandlords = this.$el.find('[name="preq_agree_contact_landlords"]');
    this.$ucuploader = this.$el.find('uc-upload-ctx-provider');
    
    this.formStep = 1;

    this.moneyFieldsSelectors = [
      '[name^="preq_employer_paycheck_"]',
      '[name^="preq_income_amount_"]',
      '[name="preq_savings"]',
      '[name="preq_expenses_student_loan"]',
      '[name="preq_expenses_auto"]',
      '[name="preq_expenses_credit_cards"]',
      '[name="preq_expenses_other_debts"]',
      '[name="preq_expenses_other_obligations"]',
    ];
    this.numberFieldSelectors = [
      '[name="preq_children"]',
    ];

    this.inputsState = {};
    this.initInputsState();

    this.bindEvents();

    // temporary
    window.grapp.preq = this;
    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  // set initial state of inputs
  initInputsState() {
    // set money fields to text type
    this.$inputs.filter(this.moneyFieldsSelectors.join(', ')).attr('type', 'text');

    this.inputsState = {};
    this.$inputs.each((i, input) => {
      const $input = $(input);
      const name = $input.attr('name');
      if ($input.attr('type') === 'checkbox') {
        this.inputsState[name] = $input.prop('checked') ? 'yes' : 'no';
      } else if ($input.attr('type') === 'radio') {
        this.inputsState[name] = $input.prop('checked') ? $input.val() : (this.inputsState[name] || '');
      } else {
        this.inputsState[name] = $input.val();
      }
    });
  
    this.initConditionedFields();
  }

  initConditionedFields() {
    this.$conditionalFields.each((i, field) => {
      const $field = $(field);
      const $fieldWrap = $field.closest('.form_input_wrap');
      let $conditionField = this.$el.find(`[name="${$field.data('conditioned-by')}"]`);
      
      if (!$conditionField.length) {
        return;
      }
      
      const value = this.inputsState[$conditionField.attr('name')];
      
      if (value === 'yes' || value === 'true') {
        $fieldWrap.show();
        $field.attr('required', true);
      } else {
        $fieldWrap.hide();
        $field.removeAttr('required');
      }

      $conditionField.on('change', (e) => {
        const $input = $(e.target);
        const value = $input.val();
        if (value === 'yes' || value === 'true') {
          $fieldWrap.show();
          $field.attr('required', true);
        } else {
          $fieldWrap.hide();
          $field.removeAttr('required');
        }
      });
    });
  
    // conditional address handled separately because they are added dynamically (repeater fields)
    const $addressFieldsGroup = this.$el.find('[data-field-group-name="address"] [data-field-group-index]');
    $addressFieldsGroup.each((i, fieldGroup) => {
      this.initConditionalLandlordFields($(fieldGroup));
    });
    // this.initConditionalLandlordFields($addressFieldsGroup);
    // conditional employments handled separately because they are added dynamically (repeater fields)
    const $employmentFieldsGroup = this.$el.find('[data-field-group-name="employer"] [data-field-group-index]');
    $employmentFieldsGroup.each((i, fieldGroup) => {
      this.initConditionalEmploymentFields($(fieldGroup));
    });
  }

  initConditionalLandlordFields($fieldGroup) {
    if (!$fieldGroup
        || $fieldGroup.find('[name^="preq_residency_type_"]').length === 0) {
      console.log('no residency type field found');
      return;
    }
    // show landlord fields if residency type is 'rent'
    const $llFieldGroup = $fieldGroup.find('[data-landlord-fields]');
    const fieldGroupIndex = $fieldGroup.data('field-group-index');
    const $residencyTypeField = this.$el.find(`[name="preq_residency_type_${fieldGroupIndex}"]:not([data-condition-init])`);
    const residencyTypeValue = this.inputsState[`preq_residency_type_${fieldGroupIndex}`];
    const $llEmail = $llFieldGroup.find(`[name="preq_landlords_email_${fieldGroupIndex}"]`);

    const $agreeContactLLWrap = this.$agreeContactLandlords.closest('.form_radio_group');
    const $allRestTypeFields = this.$el.find(`[name^="preq_residency_type_"]`);
    // if any of all residency type fields is 'rent', show agree contact landlords checkbox
    let isAnyRent = $allRestTypeFields.toArray().some((field) => {
      return this.inputsState[field.name] === 'rent';
    });
    $llFieldGroup.find('input').attr('data-condition-init', true);

    if (residencyTypeValue === 'rent') {
      $llFieldGroup.show();
      $llEmail.attr('required', 'required');
    } else {
      $llFieldGroup.hide();
      $llEmail.removeAttr('required');
    }

    if (isAnyRent) {
      $agreeContactLLWrap.show();
      this.$agreeContactLandlords.attr('required', 'required');
    } else {
      $agreeContactLLWrap.hide();
      this.$agreeContactLandlords.removeAttr('required');
    }

    $residencyTypeField.on('change', (e) => {
      const $input = $(e.target);
      const value = $input.val();
      isAnyRent = $allRestTypeFields.toArray().some((field) => {
        return this.inputsState[field.name] === 'rent';
      });

      if (value === 'rent') {
        $llFieldGroup.show();
        $llEmail.attr('required', 'required');
      } else {
        $llFieldGroup.hide();
        $llEmail.removeAttr('required');
      }

      if (isAnyRent) {
        $agreeContactLLWrap.show();
        this.$agreeContactLandlords.attr('required', 'required');
      } else {
        $agreeContactLLWrap.hide();
        this.$agreeContactLandlords.removeAttr('required');
      }
    });
  }

  initConditionalEmploymentFields($fieldGroup) {
    if (!$fieldGroup 
        || $fieldGroup.find('[name^="preq_employment_status_"]').length === 0) {
      console.log('no employment status field found');
      return;
    }
    // show/hide employment fields based on employment status
    const fieldGroupIndex = $fieldGroup.data('field-group-index');
    const $empFieldGroup = $fieldGroup.find('[data-employment-fields]');
    const $empStatusField = this.$el.find(`[name="preq_employment_status_${fieldGroupIndex}"]:not([data-condition-init])`);
    const empStatusValue = this.inputsState[`preq_employment_status_${fieldGroupIndex}`];
    const $empFields = $empFieldGroup.find('input, select, textarea');
    const $agreeContactEmployers = this.$el.find('[name="preq_agree_contact_employers"]');
    const $agreeContactEmployersWrap = $agreeContactEmployers.closest('.form_radio_group');
    const $allEmpStatusFields = this.$el.find(`[name^="preq_employment_status_"]`);
    // if any of all employment status fields is not 'unemployed', show agree contact employers checkbox
    let isAnyEmployed = $allEmpStatusFields.toArray().some((field) => {
      console.log(`${field.name}: `, this.inputsState[field.name]);
      return (
        this.inputsState[field.name] !== undefined 
        && this.inputsState[field.name] !== '' 
        && this.inputsState[field.name] !== 'unemployed'
      );
    });
    $empFieldGroup.attr('data-condition-init', true);
    $empFieldGroup.find('input').attr('data-condition-init', true);

    const empRequired = [
      'preq_employer_name_',
      'preq_employment_title_',
      'preq_employment_start_month_',
      'preq_employment_start_year_',
      'preq_employment_end_month_',
      'preq_employment_end_year_',
      'preq_employer_paycheck_',
      'preq_employment_pay_freq_',
      'preq_employer_address_',
      'preq_employment_ref_name_'
    ];

    if (empStatusValue && empStatusValue !== 'unemployed') {
      $empFieldGroup.show();
      $empFields.filter(empRequired.map(field => `[name^="${field}${fieldGroupIndex}"]`).join(', ')).attr('required', 'required');
    } else {
      $empFieldGroup.hide();
      $empFields.removeAttr('required');
    }

    console.log('isAnyEmployed: ', isAnyEmployed);
    if (isAnyEmployed) {
      $agreeContactEmployersWrap.show();
      $agreeContactEmployers.attr('required', 'required');
    } else {
      $agreeContactEmployersWrap.hide();
      $agreeContactEmployers.removeAttr('required');
    }

    $empStatusField.on('change', (e) => {
      const $input = $(e.target);
      const value = $input.val();
      isAnyEmployed = $allEmpStatusFields.toArray().some((field) => {
        return this.inputsState[field.name] !== 'unemployed';
      });

      if (value !== 'unemployed') {
        $empFieldGroup.show();
        $empFields.filter(empRequired.map(field => `[name^="${field}${fieldGroupIndex}"]`).join(', ')).attr('required', 'required');
      } else {
        $empFieldGroup.hide();
        $empFields.removeAttr('required');
      }

      if (isAnyEmployed) {
        $agreeContactEmployersWrap.show();
        $agreeContactEmployers.attr('required', 'required');
      } else {
        $agreeContactEmployersWrap.hide();
        $agreeContactEmployers.removeAttr('required');
      }
    });
  }

  // clear all inputs
  clearInputs() {
    this.$inputs.each((i, input) => {
      const $input = $(input);
      $input.val('');
    });
    this.initInputsState();
  }

  // update inputs state
  updateInputsState(fieldName, value) {
    this.inputsState[fieldName] = value;
    const $fileFields = this.$inputs.filter('[role="uploadcare-uploader"]');
    const $input = this.$inputs.filter(`[name="${fieldName}"]`);

    if ($input.attr('type') === 'radio') {
      $input.filter(`[value="${value}"]`).prop('checked', true);
    } else if ($input.attr('type') === 'checkbox') {
      const shouldBeChecked = value === 'yes' || value === 'true';
      $input.prop('checked', shouldBeChecked);
      $input.val(shouldBeChecked ? 'yes' : 'no');
    } else if ($fileFields.filter(`[name="${fieldName}"]`).length > 0) {
      const $fieldInfo = getFileFieldInfoEl($input, this.inputsState);
      const $fileFieldWrap = $input.closest('.form_field_file_wrap');
      $fileFieldWrap.find('.form_file_field_info').remove();
      $fileFieldWrap.append($fieldInfo);
    } else {
      $input.val(value);
    }

    this.initConditionedFields();
    // format money fields
    if (this.moneyFieldsSelectors.includes(`[name="${fieldName}"]`)
    || this.moneyFieldsSelectors.includes(`[name^="${fieldName.slice(0, -1)}"]`)) {
      const $field = this.$inputs.filter(`[name="${fieldName}"]`);
      $field.attr('type', 'text');
      onMoneyValueChange($field);
    }
    // format number fields
    if (this.numberFieldSelectors.includes(`[name="${fieldName}"]`)) {
      const $field = this.$inputs.filter(`[name="${fieldName}"]`);
      $field.attr('type', 'text');
      onMoneyValueChange($field);
      $field.val($field.val().replace('$', ''));
    }
  }

  bindEvents() {
    this.$el.on('change', 'input, select, textarea, hidden', this.onInputChange.bind(this));
    this.$el.on('input', 'input[type="tel"]', (e) => onPhoneValueChange($(e.target)));
    this.$el.on('blur', this.moneyFieldsSelectors.join(', '), this.onBlurMoneyField.bind(this));
    this.$el.on('focus', this.moneyFieldsSelectors.join(', '), this.onFocusMoneyField.bind(this));
    this.$el.on('blur', this.numberFieldSelectors.join(', '), this.onBlurNumberField.bind(this));
    this.$el.on('focus', this.numberFieldSelectors.join(', '), this.onFocusNumberField.bind(this));
    this.$actionSaveStep.on('click', this.onSaveUserFields.bind(this));

    EventBus.on('user:loaded', this.getUserPreqFields.bind(this));
    EventBus.on('user:empty', this.onUserEmpty.bind(this));

    EventBus.on('repeater-fields:added', this.onRepeaterFieldsAdded.bind(this));
    EventBus.on('repeater-fields:loaded', this.onRepeaterFieldsLoaded.bind(this));
    EventBus.on('repeater-fields:deleted', this.onRepeaterFieldsDeleted.bind(this));

    EventBus.on('form-steps:navigate', this.onFormStepNavigate.bind(this));
    EventBus.on('form-steps:before-navigate', this.onBeforeNavigate.bind(this));

    this.$ucuploader.on('file-upload-success', this.onUploadCareSuccess.bind(this));
    this.$ucuploader.on('file-removed', this.onUploadCareRemove.bind(this));
  }

  onInputChange(e) {
    const $input = $(e.target);
    const name = $input.attr('name');
    let value;
    if ($input.attr('type') === 'checkbox') {
      value = $input.prop('checked') ? 'yes' : 'no';
    } else if ($input.attr('type') === 'radio') {
      value = $input.prop('checked') ? $input.val() : '';
    } else {
      value = $input.val();
    }

    this.updateInputsState(name, value);
  }

  async getUserPreqFields() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    const preq_owner_user = window.grapp.user.auth.email;
    this.updateInputsState('preq_owner_user', preq_owner_user);
    try {
      const userFieldsRes = await preqGetFields(preq_owner_user);
      if (userFieldsRes.fields) {
        // find all fields starting with 'preq_address_'
        const addressFields = Object.keys(userFieldsRes.fields).filter(key => key.startsWith('preq_address_'));
        addressFields.forEach((field, i) => {
          // skip the first address field
          if (i > 0) {
            EventBus.emit('prequalification:add-group', 'address');
          }
        });
        // find all fields starting with 'preq_employer_name_'
        const employerFields = Object.keys(userFieldsRes.fields).filter(key => key.startsWith('preq_employer_name_'));
        employerFields.forEach((field, i) => {
          // skip the first address field
          if (i > 0) {
            EventBus.emit('prequalification:add-group', 'employer');
          }
        });
        // find all fields starting with 'preq_income_source_'
        const incomeFields = Object.keys(userFieldsRes.fields).filter(key => key.startsWith('preq_income_source_'));
        incomeFields.forEach((field, i) => {
          // skip the first address field
          if (i > 0) {
            EventBus.emit('prequalification:add-group', 'income');
          }
        });
        // find all fields starting with 'preq_coapp_first_name_'
        const coappFields = Object.keys(userFieldsRes.fields).filter(key => key.startsWith('preq_coapp_email_'));
        coappFields.forEach((field, i) => {
          // skip the first coapp field
          if (i > 0) {
            EventBus.emit('prequalification:add-group', 'coapplicants');
          }
        });
      } else {
        // get user's coapplicants
        const coappRes = await coappGetUserCoapplicants(preq_owner_user);
        if (coappRes.success && coappRes.fields) {
          const coapplicants = coappRes.fields.coapplicants_emails || [];
          coapplicants.forEach((coapp, i) => {
            EventBus.emit('prequalification:add-group', 'coapplicants');
          });
        }
      }
      
      if (userFieldsRes.fields) {
        const userFields = userFieldsRes.fields;
        this.$inputs.each((i, input) => {
          const $input = $(input);
          const name = $input.attr('name');
          if (userFields[name]) {
            this.updateInputsState(name, userFields[name]);
          }
        });
      }
    } catch(err) {
      console.log('Error getting user preq fields: ', err);
    }
  }

  async onSaveUserFields() {
    const errors = this.validateFields();
    if (errors.length > 0) {
      return;
    };

    try {
      const saveRequest = await preqSaveFields(this.inputsState);
      if (saveRequest) {
        EventBus.emit('toast', {type: 'success', message: 'Saved!'});
        console.log('user fields saved successfully', saveRequest);
      } else {
        throw new Error('Save failed');
      }
    } catch(err) {
      EventBus.emit('toast', {type: 'error', message: 'Save failed. Please try again.'});
      console.log('Error saving user preq fields: ', err);
    }
  }

  getValidationErrors() {
    const fieldsToValidate = {
      '1': [
        { name: 'preq_legal_first_name', validators: [validators.required] },
        { name: 'preq_legal_last_name', validators: [validators.required] },
        { name: 'preq_phone_number', validators: [validators.required, validators.phone] },
        { name: 'preq_date_of_birth', validators: [validators.required, validators.minDate, validators.maxDate] },
      ],
      // @TODO: account for repeater fields
      '2': [
        { name: 'preq_address_', validators: [validators.required] },
        { name: 'preq_start_month_', validators: [validators.required] },
        { name: 'preq_start_year_', validators: [validators.required] },
        { name: 'preq_end_month_', validators: [validators.required] },
        { name: 'preq_end_year_', validators: [validators.required] },
        { name: 'preq_residency_type_', validators: [validators.radio] },
        { name: 'preq_landlords_email_', validators: [validators.email] },
        { name: 'preq_landlords_phone_number_', validators: [validators.phone] },
      ],

      '3': [
        { name: 'preq_employment_status_', validators: [validators.radio] },
        { name: 'preq_employment_ref_phone_number_', validators: [validators.phone] },
        { name: 'preq_employment_ref_email_', validators: [validators.email] },
      ],

      '4': [
        { name: 'preq_emcon_first_name', validators: [validators.required] },
        { name: 'preq_emcon_last_name', validators: [validators.required] },
        { name: 'preq_emcon_relation', validators: [validators.required] },
        { name: 'preq_emcon_email', validators: [validators.required, validators.email] },
        { name: 'preq_emcon_phone_number_', validators: [validators.required, validators.phone] },
        { name: 'preq_children', validators: [validators.required, validators.number] },
        { name: 'preq_smoke', validators: [validators.radio] },
        { name: 'preq_pets', validators: [validators.radio] },
      ],

      '5': [
        { name: 'preq_detained_evicted', validators: [validators.radio] },
        { name: 'preq_bankruptcy', validators: [validators.radio] },
        { name: 'preq_ofac_sanctions', validators: [validators.radio] },
        { name: 'preq_sex_offender', validators: [validators.radio] },
        { name: 'preq_criminal_offense', validators: [validators.radio] },
      ],

      '6': [
        { name: 'preq_savings', validators: [validators.required, validators.money] },
        { name: 'preq_expenses_student_loan', validators: [validators.required, validators.money] },
        { name: 'preq_expenses_auto', validators: [validators.required, validators.money] },
        { name: 'preq_expenses_credit_cards', validators: [validators.required, validators.money] },
        { name: 'preq_expenses_other_debts', validators: [validators.required, validators.money] },
        { name: 'preq_expenses_other_obligations', validators: [validators.required, validators.money] },
      ],

      '7': [
        { name: 'proof_of_income', validators: [validators.required], type: 'uploadcare' },
        { name: 'proof_of_savings', validators: [validators.required], type: 'uploadcare' },
        { name: 'photo_id', validators: [validators.required], type: 'uploadcare' },
      ],

      '8': [
        { name: 'preq_agree_info_is_true', validators: [validators.checkbox] },
        { name: 'preq_agree_soft_credit', validators: [validators.checkbox] },
      ],
    };

    const stepFields = fieldsToValidate[this.formStep];
    const errors = [];
    stepFields.forEach(field => {
      const $input = this.$inputs.filter(`[name^="${field.name}"]`);
      // if is hidden field, trigger change event to update state
      if ($input.attr('type') === 'hidden' && $input.attr('role') !== 'uploadcare-uploader') {
        $input.trigger('change');
      }

      $input.each((i, input) => {
        const $_input = $(input);
        const value = $_input.val();
        field.validators.forEach(validator => {
          const currentInputName = $_input.attr('name');
          
          if ($_input.attr('type') === 'date') {
            const dateToCompare = validator === validators.minDate ? $_input.attr('min') : $_input.attr('max');
            if (!validator.validate(value, dateToCompare)) {
              errors.push({ name: currentInputName, message: validator.message });
            }
          } else {
            const validationArg = $_input.attr('type') === 'checkbox' || $_input.attr('type') === 'radio' 
              ? $input.filter(`[name="${currentInputName}"]`)
              : value;
            if (!validator.validate(validationArg)) {
              errors.push({
                name: currentInputName,
                message: validator.message,
              });
            }
          }
        }); // forEach validators
      }); // forEach $input
    }); // forEach stepFields

    return errors;
  }

  validateFields() {
    let errors = this.getValidationErrors();

    // account for conditionally required landlord fields
    if (this.formStep === 2) {
      const $landlordEmailFields = this.$el.find('[name^="preq_landlords_email_"]');
      $landlordEmailFields.each((i, field) => {
        const $field = $(field);
        if ($field.attr('required') && !$field.val()) {
          errors.push({
            name: $field.attr('name'),
            message: 'This field is required',
          });
        }
      });
      if (this.$agreeContactLandlords.attr('required') && !this.$agreeContactLandlords.prop('checked')) { 
        errors.push({ name: 'preq_agree_contact_landlords', message: 'This field is required' });
      }
    }
    // account for conditionally required details textarea fields
    let detailsFields = [];
    if (this.formStep === 4) {
      detailsFields = [
        'preq_pets_description',
      ];
      detailsFields.forEach(field => {
        const $field = this.$inputs.filter(`[name="${field}"]`);
        if ($field.attr('required') && !$field.val()) {
          errors.push({
            name: $field.attr('name'),
            message: 'This field is required if the answer above is Yes',
          });
        }
      });
    }
    if (this.formStep === 5) {
      detailsFields = [
        'preq_eviction_detail',
        'preq_bankruptcy_detail',
        'preq_ofac_sanctions_detail',
        'preq_sex_offender_detail',
        'preq_criminal_offense_detail',
      ];
      detailsFields.forEach(field => {
        const $field = this.$inputs.filter(`[name="${field}"]`);
        if ($field.attr('required') && !$field.val()) {
          errors.push({
            name: $field.attr('name'),
            message: 'This field is required if the answer above is Yes',
          });
        }
      });
    }
    // account for conditionally required employment fields
    if (this.formStep === 3) {
      const $requiredEmploymentFields = this.$el.find('[data-employment-fields] [required]');
      $requiredEmploymentFields.each((i, field) => {
        const $field = $(field);
        if ($field.val() === '') {
          errors.push({ name: $field.attr('name'), message: 'This field is required' });
        }
      });
      const $agreeContactEmployers = this.$el.find('[name="preq_agree_contact_employers"]');
      if ($agreeContactEmployers.attr('required') && !$agreeContactEmployers.prop('checked')) {
        errors.push({ name: 'preq_agree_contact_employers', message: 'This field is required' });
      }
    }
    
    if (errors.length > 0) {
      errors.forEach(error => {
        const $field = this.$inputs.filter(`[name^="${error.name}"]`);
        $field.each((i, field) => {
          const $_field = $(field);
          const isCheckbox = $_field.attr('type') === 'checkbox';
          const isRadio = $_field.attr('type') === 'radio';
          const isSelect = $_field.is('select');
          let $parent;
          if (isCheckbox) { $parent = $_field.parent().parent(); } 
          else if (isRadio) { $parent = $_field.closest('.form_radio_group'); } 
          else if (isSelect) { $parent = $_field.closest('.form_input_wrap'); }
          else { $parent = $_field.parent(); }

          if ($_field.hasClass('form_error_field')) {
            return;
          }

          $_field.addClass('form_error_field');
          if ($parent.find(`[data-msg="${error.message}"]`).length === 0) {
            const $message = $(`<div class="form_error_message" data-msg="${error.message}">${error.message}</div>`);
            if (isCheckbox) { $parent.prepend($message); } 
            else if (isRadio || isSelect) { $parent.find('.form_field_label').after($message); }
            else { $_field.before($message); }
          }
        }); // each field
      }); // each error

      EventBus.emit('prequalification:validation-error');

      // scroll to first error
      const $firstErrorField = this.$inputs.filter(`[name="${errors[0].name}"]`).first();
      const offsetTop = $firstErrorField.offset().top > 100 
        ? $firstErrorField.offset().top - 100 
        : $firstErrorField.offset().top;
      
      $('html, body').animate({
        scrollTop: offsetTop,
      }, 500);
    } else {
      this.$inputs.removeClass('form_error_field');
      this.$el.find('.form_error_message').remove();
      errors = [];
    }

    return errors;
  }

  onBeforeNavigate(stepIndex) {
    // if (stepIndex > this.formStep) {
    //   const errors = this.validateFields();
    //   EventBus.emit('form-steps:validation', errors.length === 0);
    // } else {
    //   EventBus.emit('form-steps:validation', true);
    // }

    const errors = this.validateFields();
    EventBus.emit('form-steps:validation', errors.length === 0);
  }

  onRepeaterFieldsAdded($newGroup) {
    this.$inputs = this.$inputs.add($newGroup.find('input, select, textarea, hidden'));
    this.initInputsState();
  }

  onRepeaterFieldsLoaded($newGroup) {
    this.$inputs = this.$inputs.add($newGroup.find('input, select, textarea, hidden'));
  }

  onRepeaterFieldsDeleted() {
    this.$inputs = this.$el.find('input, select, textarea, hidden');
    this.initInputsState();
  }

  onFormStepNavigate(payload) {
    // save fields on step change if advancing to next step
    if (payload.step > this.formStep) {
      this.onSaveUserFields();
    }
    this.formStep = payload.step;
  }

  onUploadCareSuccess(e) {
    const $uploader = $(e.currentTarget);
    const $input = $uploader.closest('.form_field_file_wrap').find('[role="uploadcare-uploader"]');
    const originalEvent = e.originalEvent;
    const detail = originalEvent?.detail;
    const cdnUrl = detail?.cdnUrl;

    const value = $input.val();
    const newValue = value ? `${value}, ${cdnUrl}` : cdnUrl;
    $input.val(newValue);
    this.updateInputsState($input.attr('name'), newValue);
  }

  onUploadCareRemove(e) {
    const $uploader = $(e.currentTarget);
    const $input = $uploader.closest('.form_field_file_wrap').find('[role="uploadcare-uploader"]');
    const originalEvent = e.originalEvent;
    const detail = originalEvent?.detail;
    const cdnUrl = detail?.cdnUrl;
    const value = $input.val();
    const newValue = value.replace(cdnUrl, '').replace(/, $/, '');
    
    $input.val(newValue);
    this.updateInputsState($input.attr('name'), newValue);
  }

  onBlurMoneyField(e) {
    const $input = $(e.target);
    $input.attr('type', 'text');
    onMoneyValueChange($(e.target));

    this.updateInputsState($input.attr('name'), $input.val());
  }
  onFocusMoneyField(e) {
    const $input = $(e.target);
    if ($input.val()) {
      $input.val($input.val().replace(/\D/g, ''));
    }
    $input.attr('type', 'number');

    this.updateInputsState($input.attr('name'), $input.val());
  }
  onBlurNumberField(e) {
    const $input = $(e.target);
    $input.attr('type', 'text');
    onMoneyValueChange($input);
    $input.val($input.val().replace('$', ''));

    this.updateInputsState($input.attr('name'), $input.val());
  }
  onFocusNumberField(e) {
    const $input = $(e.target);
    if ($input.val()) {
      $input.val($input.val().replace(/\D/g, ''));
    }
    $input.attr('type', 'number');

    this.updateInputsState($input.attr('name'), $input.val());
  }

  // @TODO: implement handler for no user found
  onUserEmpty() {
    console.log('User is empty');
  }

  static init() {
    $('[data-js-form="prequalification"]').each((i, el) => new PrequalificationForm(el));
  }
}

PrequalificationForm.init();
